/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 *
 * zone.js has been removed as part of the zoneless Angular migration.
 * Change detection is now handled by Angular's signal-based scheduler.
 */

/** *************************************************************************************************
 * APPLICATION IMPORTS
 */
(window as any).global = window; // Refer: https://stackoverflow.com/a/51380307
